// Experience.jsx
import React from 'react';
import { motion } from 'framer-motion';
import FreeCharge from '../assets/Freecharge.png'; // Replace with FreeCharge logo
import deloitteLogo from '../assets/Deloitte.png'; // Replace with Deloitte logo
import Northeastern from '../assets/Northeastern.jpg'; // Replace with Northeastern logo
import Atlas from '../assets/ATLAS-SP-Partners.jpg'
const experiences = [
  {
    logo: Atlas,
    role: 'Software Engineering Co-op',
    company: 'ATLAS SP Partners',
    location: 'New York City, NY',
    duration: 'Jan 2025 — Present',
    bullets: [
      'Designed and developed a Full Stack Scalable Credit Agreement Parsing AI solution using Next.js, C#, ChromaDB and Azure AI',
      'Enhanced the UI performance by implementing a custom filtering and search mechanism in a high-impact Angular dropdown component, reducing view customization time and improving user experience.',
      'Hosted the applications on AWS EC2 Ubuntu instance, reducing deployment time by 90% using Terraform, CI/CD pipelines, and Jenkins.',
      'Implemented robust CI/CD pipelines for Next.js and React and ASP.NET projects with multiple teams leveraging the Azure build and deploy pipelines, reducing the deployment time by 80%.',
    ],
  },
  {
    logo: Northeastern,
    role: 'Software Development Research Assistant',
    company: 'Northeastern University',
    location: 'Boston, MA',
    duration: 'Feb 2024 — Jan 2025',
    bullets: [
      'Led the development of a real-time LLM-based ChatBotAI serving 100+ users using Node.js, Express.js, Socket.io, and React.',
      'Engineered a Python, Django, and AWS RDS-based NLP-driven survey platform integrating 8 Large Language Models, enhancing user participation by 80%.',
      'Hosted the applications on AWS EC2 Ubuntu instance, reducing deployment time by 90% using Terraform, CI/CD pipelines, and Jenkins.',
      'Built an automated grading system using AWS OpenSearch RAG and AWS Bedrock, reducing manual grading time by 75% and improving feedback accuracy by 30%.',
      'Developed a Python-based CLI tool using Boto3 for AWS configuration troubleshooting, leveraging EC2, VPC, and IAM.',
    ],
  },
  {
    logo: deloitteLogo,
    role: 'Software Engineer',
    company: 'Deloitte',
    location: 'Bengaluru, IN',
    duration: 'Jun 2022 — Aug 2023',
    bullets: [
      'Transformed legacy EGL data loader into efficient SpringBoot Microservices, reducing server cost by 100% and improving performance by 2x.',
      'Developed scalable RESTful APIs using Java, SpringBoot, and AWS EC2, increasing performance by 60%.',
      'Devised low-latency Spring Batches to automate benefits redetermination applications, processing 1M+ records efficiently from IBM DB2.',
      'Delivered an agency portal module built using Spring and React to serve 475,000+ students receiving electronic benefits.',
    ],
  },
  {
    logo: FreeCharge,
    role: 'Software Development Engineering Intern',
    company: 'FreeCharge Payments Technologies',
    location: 'Mumbai, IN',
    duration: 'May 2021 — Jul 2021',
    bullets: [
      'Enhanced OAuth security module using Python and DynamoDB, providing 40% increased token customization flexibility.',
      'Developed an efficient AWS S3 file management utility, optimizing cloud storage solutions by 20%.',
    ],
  },
];

const Experience = () => {
  return (
    <motion.div
      className="experience-section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <h2 className="experience-title">Experience</h2>
      <div className="experience-container">
        {experiences.map((exp, index) => (
          <motion.div
            key={index}
            className="experience-card"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.3 }}
          >
            {/* Logo Section */}
            <div className="experience-logo">
              <img
                src={exp.logo}
                alt={`${exp.company} logo`}
                className="experience-img"
                loading="lazy"
              />
            </div>
            {/* Content Section */}
            <div className="experience-content">
              <h3 className="experience-role">{exp.role}</h3>
              <p className="experience-company">
                {exp.company} | {exp.location}
              </p>
              <p className="experience-duration">{exp.duration}</p>
              <ul className="experience-bullets">
                {exp.bullets.map((bullet, i) => (
                  <li key={i}>{bullet}</li>
                ))}
              </ul>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Experience;
